import { Button, Input, Panel } from 'appkit-react';
import { Col, Row } from 'react-bootstrap';

const ProfilePanel = ({
    showEditUserFields, firstName, setFirstName, lastName, setLastName, phone, setPhone,
    jobTitle, setJobTitle, onClickEditUserInfo, onSaveUserInfo, editUserLoading,
    updateUserLoading, setShowEditUserFields, loading, userData, getCustomPaddingStyle,
    getFirstName, getLastName, getPhoneNumber, isInValidFirstName, isInvalidLastName,
    getJobTitle, isInvalidPhoneNumber, isInvalidJobTitle, currentActiveTenantId,
}) => (
    <Panel
        title="General Information"
        className="a-increase-child-color-level-by-1"
        style={{ marginTop: '1rem' }}
        renderRight={() => (
            <>
                {!showEditUserFields ? <Button size="md" kind="secondary" onClick={() => onClickEditUserInfo()}>  Edit </Button>
                    : (
                        <>
                            <Button
                                size="md"
                                kind="secondary"
                                gray
                                onClick={() => setShowEditUserFields(false)}
                                style={{ marginRight: '0.5rem' }}
                            >
                                Cancel
                            </Button>
                            <Button
                                size="md"
                                kind="secondary"
                                onClick={() => onSaveUserInfo()}
                                isLoading={editUserLoading || updateUserLoading || loading}
                            >
                                Save
                            </Button>
                        </>
                    )}
            </>
        )}
    >

        <Row style={{ paddingBottom: '1.5rem' }}>
            <Col md={6}>
                <Row className="row-margin" style={{ marginTop: '1rem' }}>
                    <Col md={3} className="a-h6">
                        User Id
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {userData?.userId}
                    </Col>
                </Row>
                <Row
                    className="row-margin"
                    style={{
                        marginTop: '1rem',
                        paddingTop: `${getCustomPaddingStyle(showEditUserFields)}`,
                    }}
                >
                    <Col md={3} className="a-h6">
                        First name
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {getFirstName(showEditUserFields, isInValidFirstName, userData)}
                        {showEditUserFields
                            && (
                                <div>
                                    <Input
                                        type="text"
                                        name="firstName"
                                        value={firstName}
                                        onChange={e => {
                                            setFirstName(e);
                                        }}
                                    />
                                </div>
                            )}
                    </Col>
                </Row>
                <Row className="row-margin">
                    <Col md={3} className="a-h6" style={{ paddingTop: `${getCustomPaddingStyle(showEditUserFields)}` }}>
                        Last name
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {getLastName(showEditUserFields, isInvalidLastName, userData)}
                        {showEditUserFields
                            && (
                                <div>
                                    <Input
                                        type="text"
                                        name="lastName"
                                        value={lastName}
                                        onChange={e => {
                                            setLastName(e);
                                        }}
                                    />
                                </div>
                            )}
                    </Col>
                </Row>
                <Row className="row-margin">
                    <Col md={3} className="a-h6">
                        Email
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {userData?.email}
                    </Col>
                </Row>
            </Col>
            <Col md={6}>
                <Row className="row-margin" style={{ marginTop: '1rem' }}>
                    <Col md={3} className="a-h6">
                        Role
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {userData?.iamRole}
                    </Col>
                </Row>
                <Row className="row-margin">
                    <Col md={3} className="a-h6" style={{ paddingTop: `${getCustomPaddingStyle(showEditUserFields)}` }}>
                        Phone
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {getPhoneNumber(showEditUserFields, isInvalidPhoneNumber, userData)}

                        {showEditUserFields
                            && (
                                <div>
                                    <Input
                                        type="text"
                                        name="phone"
                                        value={phone}
                                        onChange={e => {
                                            setPhone(e);
                                        }}
                                    />
                                </div>
                            )}
                    </Col>
                </Row>
                <Row className="row-margin">
                    <Col md={3} className="a-h6">
                        Company
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {userData?.userTenants.filter(t => t.tenantId === currentActiveTenantId)[0].name}
                    </Col>
                </Row>
                <Row className="row-margin">
                    <Col md={3} className="a-h6" style={{ paddingTop: `${getCustomPaddingStyle(showEditUserFields)}` }}>
                        Job title
                        <span className="label">:</span>
                    </Col>
                    <Col md={8}>
                        {getJobTitle(showEditUserFields, isInvalidJobTitle, userData, currentActiveTenantId)}
                        {showEditUserFields
                            && (
                                <div>
                                    <Input
                                        type="text"
                                        name="jobTitle"
                                        value={jobTitle}
                                        onChange={e => {
                                            setJobTitle(e);
                                        }}
                                    />
                                </div>
                            )}
                    </Col>
                </Row>
            </Col>
        </Row>
    </Panel>
);

export default ProfilePanel;
